
import Navbar from './Navbar'

const Aside = () => {
    return (
        <aside className="left-sidebar">
            <div className="sidebar-header">
                <Link to="/" className="logo">
                    <h2 className="text-dark"><strong>Aegis Admin</strong></h2>
                </Link>
            </div>


            {/*
                        <Button variant="link" className="sidebartoggler" id="sidebarCollapse">
                            <i className="ti ti-x fs-8" />
                        </Button>
                     */}

            <Navbar />

        </aside>
    );
}

export default Aside;